// extracted by mini-css-extract-plugin
export default {"wrapperPanel":"WrapperPanel_wrapperPanel__xrkY-"};